import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import zhCN from 'antd/lib/locale/zh_CN';
import BasicLayout from './components/layout';
import { IntlProvider } from 'react-intl';
import type { LangConf } from './locales';
import langMap from './locales';
import { getLang, storeLang } from './utils/lang';
import { FeishuProvider } from './feishu-context';
// import { ReactKeycloakProvider } from '@react-keycloak/web';
// import keycloak from './keycloak/config';
import './main.less';
import '@/utils/sentry';
import { isPro } from '@/config/index';
import { apiJsApi } from './utils/feishu-api-jsapi';
import { isDev } from './config';
import dayjs from 'dayjs';

import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

function showSystemInfo() {
  const { __GIT_DESCRIBE__, __BUILD_TIME__ } = window?.preEnv || {
    // vite 会把 preEnv.__GIT_DESCRIBE__ 变成设置的变量。
    __GIT_DESCRIBE__: preEnv.__GIT_DESCRIBE__,
    __BUILD_TIME__: preEnv.__BUILD_TIME__,
  };
  console.info('[GIT_DESCRIBE]', __GIT_DESCRIBE__);
  console.info('[BUILD_TIME]', dayjs(__BUILD_TIME__).format('YYYY-MM-DD HH:mm:ss'));
  console.info(`From Now: ${dayjs(__BUILD_TIME__).fromNow()}. Typeof: ${typeof __BUILD_TIME__}`);
  console.info('NOW:', dayjs().format('YYYY-MM-DD HH:mm:ss'), 'NODE_ENV:', process.env.NODE_ENV);
  console.info('REACT_APP_ENVIRONMENT', process.env.REACT_APP_ENVIRONMENT);

  if (isDev) {
    console.info('REACT_APP_API_VERSION', process.env.REACT_APP_API_VERSION);
    console.info('REACT_APP_HOST', process.env.REACT_APP_HOST);
    console.info('REACT_APP_DISABLE_KEYCLOAK_ROUTE_CHECK', process.env.REACT_APP_DISABLE_KEYCLOAK_ROUTE_CHECK);
    console.info('REACT_APP_KEYCLOAK_URL', process.env.REACT_APP_KEYCLOAK_URL);
    console.info('REACT_APP_KEYCLOAK_REALM', process.env.REACT_APP_KEYCLOAK_REALM);
    console.info('REACT_APP_KEYCLOAK_CLIENT_ID', process.env.REACT_APP_KEYCLOAK_CLIENT_ID);
  }
}
showSystemInfo();

const getAntdLocale = (locale: string) => {
  const antdLocaleMap = {
    en: enUS,
    zh: zhCN,
  };
  return antdLocaleMap[locale as keyof typeof antdLocaleMap] || enUS;
};

const eventLogger = (event: unknown, error: unknown) => {
  console.debug('onKeycloakEvent', event, error);
};

const tokenLogger = (tokens: any) => {
  localStorage.setItem('token', tokens.token);
};

const App: FC = () => {
  const [lang, setLang] = useState(getLang());

  const changeLang = (value: string): void => {
    setLang(value);
    storeLang(value);
  };

  const messages: LangConf = langMap[lang] ? langMap[lang] : langMap['en-US'];
  // moment.locale(messages.locale);
  const antdLocale = getAntdLocale(messages.locale);

  useEffect(() => {
    const titleFormat: string = messages.locale === 'en' ? 'Travel' : '差旅中台';
    document.title = titleFormat;
    if (!window.sessionStorage.getItem('lang')) {
      apiJsApi();
    }
  }, []);

  return (
    // <ReactKeycloakProvider
    //   initOptions={{ onLoad: 'check-sso' }}
    //   authClient={keycloak}
    //   onEvent={eventLogger}
    //   onTokens={tokenLogger}
    // >
    <FeishuProvider>
      <IntlProvider messages={messages} locale={messages.locale}>
        <ConfigProvider locale={antdLocale}>
          <BasicLayout changeLang={changeLang} />
        </ConfigProvider>
      </IntlProvider>
    </FeishuProvider>
    // </ReactKeycloakProvider>
  );
};

export default App;
